import { useMemo } from 'react'
import { Commitment, Connection } from '@solana/web3.js'
import { env } from 'utils'

export function useSolanaConnection() {
    return useMemo(() => {
        if (!env.VITE_SOLANA_MAINNET_RPC_URL) {
            console.error('VITE_SOLANA_MAINNET_RPC_URL is not set')
            return undefined
        }
        return new Connection(env.VITE_SOLANA_MAINNET_RPC_URL)
    }, [])
}

// i can't figure out how to get stupid solana txs to confirm using sdk, so this is manual
export async function confirmSolanaTx(
    connection: Connection,
    signature: string,
    timeout = 30000,
    commitment: Commitment = 'confirmed',
) {
    const start = Date.now()

    while (Date.now() - start < timeout) {
        const { value } = await connection.getSignatureStatuses([signature])
        const status = value[0]

        if (
            status?.confirmationStatus === commitment ||
            status?.confirmationStatus === 'finalized'
        ) {
            return status
        }

        await new Promise((res) => setTimeout(res, 500)) // wait 500ms
    }

    throw new Error('Transaction confirmation timed out')
}
